import styles from "./Overlay.module.scss";

type OverlayProps = {
  className?: string;
};

export default function Overlay({ className }: OverlayProps) {
  return <div className={`${styles.Overlay} ${className}`} />;
}
